module.exports = __webpack_public_path__ + "img/rla.eeb73979.png";